<script setup>
defineProps({
  label: String,
  active: Boolean,
  inverse: Boolean,
  disabled: Boolean
})
</script>

<template>
  <button
    type="button"
    class="flex items-center gap-3 cursor-pointer border border-transparent rounded focus-visible:border-gray-500"
    :class="{ 'pointer-events-none': disabled }"
    @click.prevent="$emit('toggle', !active)"
  >
    <div v-if="label">{{ label }}</div>
    <span class="cursor-default empty:hidden" @click.stop>
      <slot />
    </span>
    <div class="relative ml-auto" :class="{ 'pointer-events-none opacity-50': disabled }">
      <div class="w-6 h-3 bg-gray-400 rounded-full shadow-inner" />
      <div
        class="absolute w-3 h-3 bg-white rounded-full shadow inset-y-0 left-0 transition-all duration-300 ease-in-out"
        :class="{ '!bg-primary translate-x-[100%]': inverse ? !active : active }"
      />
    </div>
  </button>
</template>
